import {
  CasRenderDate,
  CasStackRow,
  CasTable,
} from 'src/compass/shared/components';
import CasLink2 from 'src/compass/shared/components/CasLink/CasLink2';
import getCasTableCellValue from 'src/compass/shared/components/CasTable/getCasTableCellValue';
import { IGeneralObjectType } from 'src/compass/site/util';
import HubspotLink from 'src/compass/application/entityMaintenance/HubspotLink';
import { RenderIgnoreLastTouch } from './RenderIgnoreLastTouch';
import { RenderContactsPhone } from './RenderContactsPhone';

interface IProps {
  entityId: number
  data: IGeneralObjectType[];
  onUpdated: VoidFunction;
}

export default function ContactsTab({ entityId, data, onUpdated }: IProps) {
  return (
    <CasTable
      data={{ result: data }}
      columns={[
        {
          field: 'name',
          render: ({ row, column }) => {
            const value = getCasTableCellValue({ row, column });
            return (
              <CasStackRow alignItems="center">
                <HubspotLink id={row.id} recordPath="record/0-1" />
                {value}
              </CasStackRow>
            );
          },
        },
        {
          field: 'email',
          label: 'Email',
          render: ({ row, column }) => {
            const email = getCasTableCellValue({ row, column });
            if (!email) return null;
            return <CasLink2 href={`mailto:${email}`}>{email}</CasLink2>;
          },
        },
        {
          field: 'phone',
          label: 'Phone',
          render: ({ row }) => {
            const defaultPhones = [
              { value: row?.mobilephone, suffix: 'Mobile' },
              { value: row?.business_phone, suffix: 'Business' },
              { value: row?.phone, suffix: null },
            ];
            
            const seen = new Set<string>();

            // De-duped Phones
            const phones = defaultPhones.filter(({ value }) => {
              const normalizedPhone = value?.replace(/\D/g, '').slice(-10);

              if (!normalizedPhone) return false;
              if (seen.has(normalizedPhone)) return false;

              seen.add(normalizedPhone);
              return true;
            });

            return (
              <div>
                {phones.map(({ value, suffix }) => (
                  <RenderContactsPhone key={suffix} value={value} suffix={suffix} />
                ))}
              </div>
            );
          },
        },
        {
          field: 'lastTouchpointDate',
          label: 'Last Touchpoint',
          sx: (row: Record<string, any>) => ({ backgroundColor: row?.ignoreLastTouch && '#ddd' }),
          render: CasRenderDate,
        },
        {
          field: 'lastLRPQuoteOpenedDate',
          label: 'Last LRPQuote Open',
          render: CasRenderDate,
        },
        {
          field: 'ignoreLastTouch',
          label: 'Ignore',
          sx: (row: Record<string, any>) => ({ backgroundColor: row?.ignoreLastTouch && '#ddd' }),
          render: (props) => (
            <RenderIgnoreLastTouch
              {...props}
              entityId={entityId}
              onUpdated={onUpdated}
            />
          ),
        },
      ]}
    />
  );
}
